import { JournalSearchParam, JournalSummarySearchParam } from "../searchParams/journalSearchParam.ts";
import GenerateQuery from "./generateQuery.ts";
import FormatDate from './formatDate.ts';

export const GenerateJournalsQuery = (searchParam: JournalSearchParam) => {
    let query = GenerateQuery(searchParam);
    if (query.length == 0) query = '?';

    if (searchParam.dateTime != null)
        query += `dateTime=${FormatDate(searchParam.dateTime)}`;

    if (query == '?')
        return '';

    return query;
}

export const GenerateJournalSummaryQuery = (searchParam: JournalSummarySearchParam) => {
    let query = '?';

    if (searchParam.dateFrom != null)
        query += `dateFrom=${FormatDate(searchParam.dateFrom)}&`;
    if (searchParam.dateTo != null)
        query += `dateTo=${FormatDate(searchParam.dateTo)}&`;

    if (query == '?')
        return '';

    return query.substring(0, query.length - 1);
}